import React from 'react';
import { CalendarXIcon, ClockIcon, LayersIcon, MessageSquareIcon, MinusCircleIcon, SearchIcon, TrendingDownIcon, WalletIcon } from 'lucide-react';
import { costOfInaction } from '../data/content';
const rowIcons = [ClockIcon, TrendingDownIcon, CalendarXIcon, WalletIcon, LayersIcon, MessageSquareIcon, SearchIcon];
export function CostSection() {
  return <section aria-labelledby="costo" className="bg-ink-900" data-id="element-35" data-mp="3vpetl9o8kt8d">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" style={{
      paddingTop: "14px",
      paddingBottom: "12px"
    }} data-id="element-36" data-mp="3qth9cs9ur2qb">
        <h2 id="costo" className="text-center font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-37" data-mp="3msxfbxkksf8e">
          ¿Cuánto te cuesta no tenerlo?
        </h2>

        <div className="mt-10 overflow-hidden rounded-2xl border border-ink-600" data-id="element-38" data-mp="3ctyfn4hsftxj">
          <div className="grid grid-cols-2 bg-ink-800" data-id="element-39" data-mp="1g0mw570pxxg4">
            <p className="px-4 py-3 text-[11px] font-bold uppercase tracking-[0.15em] text-slate-400 sm:px-6 sm:text-xs" data-id="element-40" data-mp="1fy0n12y6j9vs">
              Sin Padel Pro-Pack™
            </p>
            <p className="px-4 py-3 text-[11px] font-bold uppercase tracking-[0.15em] text-red-400 sm:px-6 sm:text-xs" data-id="element-41" data-mp="p60buortbqh1">
              Coste real
            </p>
          </div>

          <ul className="divide-y divide-ink-600" data-id="element-42" data-mp="fafckye4p4az">
            {costOfInaction.map((row, index) => {
            const Icon = rowIcons[index] ?? ClockIcon;
            return <li key={row.without} className="grid grid-cols-2 items-start" data-id="element-43" data-mp="17yb7pyo1uo5n" data-mpi={index}>
                  <div className="flex gap-2.5 px-4 py-4 sm:gap-3 sm:px-6" data-id="element-44" data-mp="180fa2c6avf3t">
                    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" strokeWidth={1.75} aria-hidden="true" data-id="element-45" data-mp="1cwcq0hdnijg2" />
                    <span className="text-[13px] leading-snug text-slate-300 sm:text-sm" data-id="element-46" data-mp="y65e6ki5fyoc">{row.without}</span>
                  </div>
                  <div className="flex gap-2.5 border-l border-ink-600 px-4 py-4 sm:gap-3 sm:px-6" data-id="element-47" data-mp="1qwf4ruqnwwr3">
                    <MinusCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400/70" strokeWidth={1.75} aria-hidden="true" data-id="element-48" data-mp="1vo5jse0jo8ou" />
                    <span className="text-[13px] font-semibold leading-snug text-white sm:text-sm" data-id="element-49" data-mp="25ib4xgoabmpd">{row.cost}</span>
                  </div>
                </li>;
          })}
          </ul>
        </div>

        <p className="mt-10 text-center font-display text-xl uppercase leading-tight text-court-200 sm:text-2xl" data-id="element-50" data-mp="1vk528wunmcjg">
          El próximo fin de semana puede ser diferente.
          
        </p>
      </div>
    </section>;
}